/**
 * AJAX filter/sort/pagination for collection pages — clicking a filter, sort
 * option, or page number fetches just the "main" + "toolbar" sections via
 * Shopify's native ?sections=id1,id2 endpoint and swaps them in, instead of
 * a full page reload. URL is kept in sync via history.pushState so filters
 * stay bookmarkable/shareable, and back/forward still works.
 *
 * Only known filter/sort/pagination elements are intercepted (by class) —
 * product card links are untouched.
 */
(function () {
  'use strict';

  var LINK_SELECTOR =
    '.cvf__option, .cvf__chip, .cvf__swatch, .cvm__sidebar-clear, .cvm__empty-clear, ' +
    '.cvtb__chip, .cvtb__clear, .cvpg__btn, .cvpg__num';

  function getRoots() {
    return {
      main: document.querySelector('[data-cv-ajax="main"]'),
      toolbar: document.querySelector('[data-cv-ajax="toolbar"]'),
    };
  }

  function setLoading(isLoading) {
    var roots = getRoots();
    [roots.main, roots.toolbar].forEach(function (el) {
      if (el) el.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    });
  }

  function swap(url, pushState) {
    var roots = getRoots();
    if (!roots.main && !roots.toolbar) return;

    var ids = [];
    if (roots.main) ids.push(roots.main.getAttribute('data-section-id'));
    if (roots.toolbar) ids.push(roots.toolbar.getAttribute('data-section-id'));

    var sep = url.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = url + sep + 'sections=' + ids.join(',');

    setLoading(true);

    fetch(fetchUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (pushState !== false) {
          window.history.pushState({ fixplusAjax: true }, '', url);
        }

        Object.keys(roots).forEach(function (key) {
          var root = roots[key];
          if (!root) return;
          var sectionId = root.getAttribute('data-section-id');
          var html = data[sectionId];
          if (!html) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRoot = doc.querySelector('[data-cv-ajax="' + key + '"]');
          if (newRoot) root.replaceWith(newRoot);
        });

        // Re-wire anything that only runs once on page load: sample toggles /
        // shop variant chips on the fresh cards, and the grid/list view toggle.
        var newRoots = getRoots();
        if (window.fixplusInitProductCards && newRoots.main) {
          window.fixplusInitProductCards(newRoots.main);
        }
        if (window.fixplusInitViewToggle && newRoots.toolbar) {
          window.fixplusInitViewToggle(newRoots.toolbar);
        }
        if (window.fixplusInitFilterDrawer && newRoots.main) {
          window.fixplusInitFilterDrawer(newRoots.main);
        }

        setLoading(false);

        if (newRoots.main) {
          var top = newRoots.main.getBoundingClientRect().top + window.pageYOffset - 24;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      })
      .catch(function (error) {
        console.error('[fixplus] collection AJAX load failed, falling back to full navigation:', error);
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest(LINK_SELECTOR);
    if (!link || link.tagName !== 'A' || link.classList.contains('is-disabled')) return;
    e.preventDefault();
    swap(link.href);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.cvtb__sort');
    if (!form) return;
    e.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    var url = form.getAttribute('action') + '?' + params.toString();
    swap(url);
  });

  window.addEventListener('popstate', function () {
    swap(window.location.href, false);
  });
})();
